import { UUID } from "../generic/uuid";
import { GenderModel } from "./gender";
import { CurrencyCodeEnum, LocaleEnum } from "@vini-wine/core-enums";
import { PersonDto } from "@vini-wine/core-dtos";

export interface PersonModel extends UUID {
  // default includes
  gender: GenderModel;

  // transform
  firstName: string;
  lastName: string;
  preferredLanguage: LocaleEnum;
  preferredCurrency: CurrencyCodeEnum;
}

export const createPersonDtoFromAdminPersonModel = (
  person: PersonModel,
): PersonDto => {
  return {
    uuid: person.uuid,
    gender: person.gender,
    lastName: person.lastName,
    firstName: person.firstName,
    preferredLanguage: person.preferredLanguage,
    preferredCurrency: person.preferredCurrency,
  };
};
